import { Reveal } from "@/components/motion";

export default function SectionHeader({ eyebrow, title, highlight, subtitle, center = false, className = "" }) {
  return (
    <div className={`${center ? "mx-auto text-center" : ""} max-w-2xl ${className}`}>
      <Reveal>
        {eyebrow && <p className="label-eyebrow mb-4">{eyebrow}</p>}
      </Reveal>
      <Reveal delay={0.06}>
        <h2 className="font-display text-3xl font-extrabold leading-[1.1] tracking-tighter text-dq-ink sm:text-4xl lg:text-[2.75rem]">
          {title} {highlight && <span className="gradient-text">{highlight}</span>}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.12}>
          <p className={`mt-4 text-lg leading-relaxed text-dq-muted ${center ? "mx-auto" : ""}`}>{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
}
